<template>
  <div>
    <b-row>
      <b-col xxs="12" class="d-flex align-items-center justify-content-between">
        <h3 class="mt-2">{{ title }}</h3>
        <b-button variant="primary" @click="showModal">{{
          $t('Yeni Oluştur')
        }}</b-button>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <b-table
          ref="table"
          class="align-items-center"
          thead-class="thead-light"
          :fields="fields"
          :items="items"
          responsive
          show-empty
        >
          <template v-slot:table-busy>
            <div style="width: 100%; text-align: center">
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </template>

          <template v-slot:empty>
            <b-alert variant="warning" show
              >{{
                $t(
                  'Henüz hiç kategori eklememişsiniz, hemen yeni bir tane ekleyin'
                )
              }}!</b-alert
            >
          </template>

          <template v-slot:cell(action)="data">
            <b-dropdown class="action-button" right>
              <template v-slot:button-content>
                <i class="fas fa-ellipsis-v" />
              </template>
              <b-dropdown-item
                @click="openModal(data.item)"
                class="dropdown-item-icon"
              >
                <i class="fas fa-pen"></i>
                <span>Güncelle</span>
              </b-dropdown-item>
              <template v-if="!data.item.cannot_delete">
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item
                  @click="deleteAction(data.item.id)"
                  class="dropdown-item-icon"
                >
                  <i class="fas fa-trash"></i>
                  <span>Sil</span>
                </b-dropdown-item>
              </template>
            </b-dropdown>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row v-if="totalRows > 14">
      <b-col class="d-flex justify-content-center">
        <b-pagination
          v-model="currentPage"
          :per-page="15"
          :total-rows="totalRows"
        ></b-pagination>
      </b-col>
    </b-row>

    <b-modal ref="modal" title="SMS Kaydı" @hide="hideModal">
      <b-form-group label="Başlık">
        <b-form-input v-model="modal.name" />
      </b-form-group>
      <b-form-group label="Mesaj">
        <b-form-textarea v-model="modal.content" />
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button @click="$refs.modal.hide()">{{ $t('İptal') }}</b-button>
        <b-button
          @click="submit()"
          :disabled="buttonLoading"
          class="loading-button"
        >
          <i v-if="buttonLoading" class="fa fa-spinner"></i>
          {{ $t('Kaydet') }}</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'DefinitionsTable',
  props: ['type', 'title'],

  data() {
    return {
      buttonLoading: false,
      currentPage: 1,
      totalRows: 1,
      fields: [
        { key: 'name', label: 'Başlık' },
        { key: 'content', label: 'Mesaj' },
        {
          key: 'action',
          label: 'İşlem',
          thStyle: { width: '100px !important' },
        },
      ],
      definitionOptions: [],
      modal: {
        name: '',
        content: '',
        type: '',
      },
    };
  },
  methods: {
    ...mapActions([
      'getDefinitions',
      'createDefinition',
      'updateDefinition',
      'deleteDefinition',
    ]),
    submit() {
      this.buttonLoading = true;
      if (this.modal.id) {
        this.updateDefinition(this.modal)
          .then((res) => {
            this.success(res.data.message);
            this.buttonLoading = false;
            this.$refs.table.refresh();
            this.$refs.modal.hide();
          })
          .catch((error) => {
            this.buttonLoading = false;
            this.error(error.response.data.message);
          });
      } else {
        this.createDefinition(this.modal)
          .then((res) => {
            this.success(res.data.message);
            this.buttonLoading = false;
            this.$refs.table.refresh();
            this.$refs.modal.hide();
          })
          .catch((error) => {
            this.buttonLoading = false;
            this.error(error.response.data.message);
          });
      }
    },
    deleteAction(id) {
      this.$swal({
        icon: 'warning',
        title: 'Dikkat',
        text: 'Kayıt silinecektir, emin misiniz?',
      }).then((ok) => {
        if (ok.value) {
          this.deleteDefinition(id)
            .then((res) => {
              this.success(res.data.message);
              this.$refs.table.refresh();
            })
            .catch((error) => {
              this.error(error.response.data.message);
            });
        }
      });
    },
    hideModal() {
      this.modal = {
        name: '',
        type: this.type,
        parent: null,
      };
    },
    openModal(data) {
      this.modal = data;
      this.modal.parent = this.definitionOptions.find(
        (item) => item.value === data.parent_id
      );
      this.showModal();
    },
    showModal() {
      this.$refs.modal.show();
    },
    items() {
      return this.getDefinitions(this.parameters())
        .then((json) => json.data)
        .then((res) => {
          this.currentPage = res.current_page;
          this.totalRows = res.total;
          return res.data;
        });
    },
    parameters() {
      const params = {};
      params.type = this.type;

      return params;
    },
  },
  mounted() {
    this.modal.type = this.type;
  },
};
</script>
